 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		73: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		73: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"8":"admin-playlet-vote","9":"admin-topic-2023-vote","10":"admin-topic-vote","11":"admin-vote","13":"403","14":"404","15":"500","16":"admin-agreement","17":"admin-audit-report","18":"admin-author","19":"admin-authors","20":"admin-done","21":"admin-home","22":"admin-message","23":"admin-platform-script","24":"admin-platform-scripts","25":"admin-playlet-audit-report","26":"admin-playlet-platform-script","27":"admin-playlet-recommend-report","28":"admin-playlet-report","29":"admin-playlet-script","30":"admin-playlet-setting","31":"admin-playlet-task-report","32":"admin-playlet-time-report","33":"admin-recommend-report","34":"admin-report","35":"admin-script","36":"admin-script-list-step","37":"admin-setting","38":"admin-task-report","39":"admin-time-report","40":"admin-topic-2023-audit-report","41":"admin-topic-2023-export","42":"admin-topic-2023-full-report","43":"admin-topic-2023-report","44":"admin-topic-2023-script","45":"admin-topic-2023-task-report","46":"admin-topic-audit-report","47":"admin-topic-export","48":"admin-topic-report","49":"admin-topic-script","50":"admin-topic-setting","51":"admin-topic-task-report","52":"admin-undo","53":"agreement","54":"customer-agreement","55":"customer-contact","56":"customer-home","57":"customer-password","58":"customer-playlet-script","59":"customer-playlet-upload","60":"customer-script","61":"customer-topic-2023-home","62":"customer-topic-2023-script","63":"customer-topic-2023-upload","64":"customer-topic-home","65":"customer-topic-script","66":"customer-topic-upload","67":"customer-upload","68":"home","69":"home-layout","70":"icons","71":"login"}[chunkId]||chunkId) + "." + {"0":"772e335d","1":"1ac23e97","2":"88f16c95","3":"433ba0b6","4":"649f895a","5":"0460d53e","6":"f17c21b3","7":"e5fe7248","8":"a22b3941","9":"5e1599b2","10":"31d92deb","11":"7e30e386","12":"8b15c918","13":"d31cbbff","14":"5463d26b","15":"f3adad30","16":"7df0ef30","17":"858f883a","18":"87bb8000","19":"fbe4d76c","20":"40917e20","21":"3a5d9ee1","22":"fe265fc4","23":"c1de9927","24":"b9f6f662","25":"94fbeed6","26":"efee13b5","27":"8bf24e43","28":"5cac3813","29":"aaf0a356","30":"19f71140","31":"6f795691","32":"73834016","33":"f13cf67c","34":"ff58b65b","35":"4ddf02a1","36":"9df4adaa","37":"b46092c7","38":"55570a25","39":"b1d5765c","40":"54a53ff6","41":"61fc4daf","42":"4f8cf064","43":"602e4145","44":"9d294973","45":"6f330c09","46":"d9823e53","47":"902e1b55","48":"a575b62c","49":"b654e0c3","50":"64f79db7","51":"25c2abbc","52":"60e739e2","53":"4dc2a03c","54":"5f29d592","55":"bcd468e2","56":"e5bac4e0","57":"72f3ed6e","58":"93b7dc96","59":"ab495c52","60":"c5dbc5fd","61":"a09b66ab","62":"920f2a02","63":"8ef45d4d","64":"5ddc8bae","65":"9d1dc6d3","66":"dd0338f6","67":"ed842393","68":"f377850d","69":"74a4bf3c","70":"75cb2710","71":"f44ef3df","75":"24adbf73","76":"36a64720"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"16":1,"18":1,"19":1,"22":1,"23":1,"24":1,"26":1,"27":1,"28":1,"29":1,"30":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"39":1,"43":1,"44":1,"48":1,"49":1,"50":1,"55":1,"57":1,"62":1,"63":1,"65":1,"68":1,"70":1,"71":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"8":"admin-playlet-vote","9":"admin-topic-2023-vote","10":"admin-topic-vote","11":"admin-vote","13":"403","14":"404","15":"500","16":"admin-agreement","17":"admin-audit-report","18":"admin-author","19":"admin-authors","20":"admin-done","21":"admin-home","22":"admin-message","23":"admin-platform-script","24":"admin-platform-scripts","25":"admin-playlet-audit-report","26":"admin-playlet-platform-script","27":"admin-playlet-recommend-report","28":"admin-playlet-report","29":"admin-playlet-script","30":"admin-playlet-setting","31":"admin-playlet-task-report","32":"admin-playlet-time-report","33":"admin-recommend-report","34":"admin-report","35":"admin-script","36":"admin-script-list-step","37":"admin-setting","38":"admin-task-report","39":"admin-time-report","40":"admin-topic-2023-audit-report","41":"admin-topic-2023-export","42":"admin-topic-2023-full-report","43":"admin-topic-2023-report","44":"admin-topic-2023-script","45":"admin-topic-2023-task-report","46":"admin-topic-audit-report","47":"admin-topic-export","48":"admin-topic-report","49":"admin-topic-script","50":"admin-topic-setting","51":"admin-topic-task-report","52":"admin-undo","53":"agreement","54":"customer-agreement","55":"customer-contact","56":"customer-home","57":"customer-password","58":"customer-playlet-script","59":"customer-playlet-upload","60":"customer-script","61":"customer-topic-2023-home","62":"customer-topic-2023-script","63":"customer-topic-2023-upload","64":"customer-topic-home","65":"customer-topic-script","66":"customer-topic-upload","67":"customer-upload","68":"home","69":"home-layout","70":"icons","71":"login"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"23a0c7d7","3":"2806a495","4":"9487b15c","5":"fb8f0236","6":"591f85ef","7":"179947bf","8":"43e9d378","9":"725b7aba","10":"df5c5cfd","11":"2fb83751","12":"bae87a2d","13":"9b74ff39","14":"9b74ff39","15":"31d6cfe0","16":"873021ad","17":"31d6cfe0","18":"e559eec8","19":"86bcf679","20":"31d6cfe0","21":"31d6cfe0","22":"514194db","23":"2c577fb1","24":"e348c820","25":"31d6cfe0","26":"2c577fb1","27":"36e686b6","28":"16c209b4","29":"3a46351a","30":"da6aceea","31":"31d6cfe0","32":"79e21b55","33":"8aca493c","34":"41b683a5","35":"dfa68b1b","36":"31ec54ba","37":"f8fbf79c","38":"31d6cfe0","39":"79e21b55","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"ca2b3939","44":"cc91d993","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"95cb799c","49":"ea43edbc","50":"e001d33e","51":"31d6cfe0","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"cdfd341f","56":"31d6cfe0","57":"60d1d2e0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"ef396bb3","63":"4cccf027","64":"31d6cfe0","65":"9db8cf18","66":"31d6cfe0","67":"31d6cfe0","68":"85d09d84","69":"31d6cfe0","70":"b377e1f4","71":"19e5343d","75":"31d6cfe0","76":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//static.linghemedia.com.cn/qgw/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpqgw-script-f2e"] = this["webpackJsonpqgw-script-f2e"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
